export default __webpack_public_path__ + "static/media/1.968c5792.jpg";